import React, { useEffect, useState, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Ticket, RefreshCw } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { api } from '../App';

const LOGO = 'https://customer-assets-0z36b82j.emergentagent.net/job_notts-gujarati/artifacts/8ofk94lm_GS_logo.webp';
const COLORS = {
  'VALID — NOT USED': 'bg-[hsl(var(--lux-royal))]',
  'ALREADY USED': 'bg-red-800', CANCELLED: 'bg-red-800', REFUNDED: 'bg-red-800', INVALID: 'bg-red-800',
};

export default function VerifyTicket() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => { setLoading(true); try { setData(await api.get(`/api/verify/ticket/${token}`)); } catch { setData({ status: 'INVALID' }); } setLoading(false); }, [token]);
  useEffect(() => { load(); }, [load]);
  const status = data?.status || 'INVALID';

  return (
    <div className="min-h-[70vh] bg-[hsl(var(--lux-ivory))] py-10 px-4" data-testid="verify-ticket-page">
      <div className="max-w-md mx-auto text-center">
        <img src={LOGO} alt="Gujarat Samaj Nottingham" className="w-20 h-20 mx-auto rounded-full shadow-md" />
        <p className="mt-2 text-xs tracking-[0.3em] uppercase text-[hsl(var(--lux-gold))]">Event Ticket</p>
        <Card className="mt-4 border-2 border-[hsl(var(--lux-gold))] overflow-hidden text-left">
          <div className={`${COLORS[status] || 'bg-red-800'} text-white px-6 py-5 flex items-center gap-3`}>
            <Ticket className="w-7 h-7" />
            <div className="font-bold text-lg" data-testid="verify-ticket-status">{loading ? 'Checking…' : status}</div>
          </div>
          <CardContent className="p-6 text-sm space-y-2">
            {!loading && data?.event_title && (<>
              <div><span className="text-[hsl(var(--lux-ink)/0.6)]">Event:</span> <strong>{data.event_title}</strong></div>
              {data.event_day && <div><span className="text-[hsl(var(--lux-ink)/0.6)]">Date:</span> {data.event_day}</div>}
              {data.ticket_type && <div><span className="text-[hsl(var(--lux-ink)/0.6)]">Category:</span> {data.ticket_type} · Admit {data.admit}</div>}
              {data.checked_in_at && <div><span className="text-[hsl(var(--lux-ink)/0.6)]">Checked in:</span> {new Date(data.checked_in_at).toLocaleString('en-GB')}</div>}
            </>)}
            <p className="pt-3 text-[11px] text-[hsl(var(--lux-ink)/0.55)]">Entry is confirmed only when scanned by Gujarat Samaj gate staff. This page shows the live ticket status and contains no personal data.</p>
            <div className="pt-2 flex gap-2"><Button size="sm" variant="outline" onClick={load}><RefreshCw className="w-4 h-4 mr-2" /> Re-check</Button><Link to="/events"><Button size="sm" variant="ghost">Events</Button></Link></div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
